/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitorMemberRead } from './CompetitorMemberRead';
import {
    CompetitorMemberReadFromJSON,
    CompetitorMemberReadFromJSONTyped,
    CompetitorMemberReadToJSON,
    CompetitorMemberReadToJSONTyped,
} from './CompetitorMemberRead';

/**
 * Schema for reading a competitor.
 * @export
 * @interface CompetitorRead
 */
export interface CompetitorRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    added_by: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitorRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    join_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitorRead
     */
    organization_name?: string | null;
    /**
     * 
     * @type {Array<CompetitorMemberRead>}
     * @memberof CompetitorRead
     */
    members?: Array<CompetitorMemberRead>;
}

/**
 * Check if a given object implements the CompetitorRead interface.
 */
export function instanceOfCompetitorRead(value: object): value is CompetitorRead {
    if (!('event_id' in value) || value['event_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('added_by' in value) || value['added_by'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function CompetitorReadFromJSON(json: any): CompetitorRead {
    return CompetitorReadFromJSONTyped(json, false);
}

export function CompetitorReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitorRead {
    if (json == null) {
        return json;
    }
    return {
        
        'event_id': json['event_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'id': json['id'],
        'added_by': json['added_by'],
        'created_at': (new Date(json['created_at'])),
        'join_code': json['join_code'] == null ? undefined : json['join_code'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(CompetitorMemberReadFromJSON)),
    };
}

export function CompetitorReadToJSON(json: any): CompetitorRead {
    return CompetitorReadToJSONTyped(json, false);
}

export function CompetitorReadToJSONTyped(value?: CompetitorRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_id': value['event_id'],
        'organization_id': value['organization_id'],
        'name': value['name'],
        'id': value['id'],
        'added_by': value['added_by'],
        'created_at': ((value['created_at']).toISOString()),
        'join_code': value['join_code'],
        'organization_name': value['organization_name'],
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(CompetitorMemberReadToJSON)),
    };
}

